export type ScheduleMode = 'shift' | 'weekly' | 'daily';

export interface IBreakConfig {
  title: string;
  start: string;
  end: string;
}

export interface IDayConfig {
  isDayOff: boolean;
  startedAt: string | null;
  finishedAt: string | null;
  breaks: IBreakConfig[];
}

export interface IWeeklyConfig {
  monday: IDayConfig;
  tuesday: IDayConfig;
  wednesday: IDayConfig;
  thursday: IDayConfig;
  friday: IDayConfig;
  saturday: IDayConfig;
  sunday: IDayConfig;
}

export interface IShiftConfig {
  daysRunning: number;
  daysOver: number;
  workingDays: IDayConfig[];
}

export interface IDailyConfig {
  startedAt: string;
  finishedAt: string;
  breaks: IBreakConfig[];
}

export type ScheduleFormConfig = IWeeklyConfig | IShiftConfig | IDailyConfig;

export interface ISchedulePeriod {
  id: string;
  ruleIds: string[];
  mode: ScheduleMode;
  dateStart: string;
  dateEnd?: string;
  config: ScheduleFormConfig;
}

export const DAY_NAMES_ENG: Record<string, string> = {
  monday: 'Пн',
  tuesday: 'Вт',
  wednesday: 'Ср',
  thursday: 'Чт',
  friday: 'Пт',
  saturday: 'Сб',
  sunday: 'Вс',
};

export const WEEK_DAYS_ENG = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
] as const;
export type WeekDayEng = (typeof WEEK_DAYS_ENG)[number];
